<template>
  <InputFieldForm
    :id="id"
    :tooltip="tooltip"
    :label="label"
    :required="isRequired"
    :validation-message="errors[0]"
    :disclaimer="disclaimer"
    :icon="icon"
  >
    <input
      :id="id"
      ref="inputElement"
      v-model="model"
      :aria-invalid="errors[0] ? true : undefined"
      :type="type"
      :disabled="disabled"
      class="form-control"
      :aria-describedby="validationMessageId"
      v-bind="$attrs"
    >
  </InputFieldForm>
</template>

<script lang="ts" setup>
import InputFieldForm from '@/VueComponents/SharedComponents/InputFields/InputFieldForm.vue';
import InputFieldElementIdGenerator from '@/VueComponents/SharedComponents/InputFields/utils/inputFieldElementIdGenerator';
import ValidationRules from '@/Types/Validation/validationRules';
import { useField } from 'vee-validate';
import { ref } from 'vue';

defineOptions({
  inheritAttrs: false
});

const props = withDefaults(defineProps<{
  id: string,
  label?: string,
  tooltip?: string,
  validationRules?: ValidationRules,
  disabled?: boolean,
  type?: string,
  disclaimer?: string,
  icon?: string
}>(), {
  required: false,
  label: undefined,
  tooltip: undefined,
  validationRules: undefined,
  disabled: false, type: 'text',
  disclaimer: undefined,
  icon: undefined
});

if (!props.id) {
  console.error(`Unique 'id' should be provided.`);
}

const inputElement = ref<HTMLElement>();

let isRequired = false;
if (props.validationRules?.required) {
  isRequired = true;
}

const validationMessageId = InputFieldElementIdGenerator.getValidationMessageId(props.id);

const model = defineModel<string>();
const { errors, validate } = useField(props.id, props.validationRules, { syncVModel: true });

async function isValid() {
  const result = await validate();
  return result.valid;
}

function focus() {
  inputElement.value?.focus();
}

defineExpose({
  isValid,
  focus
});
</script>
